import { FRONTEND_ROUTES, SIDEBAR_LINKS } from "@/constants"
import { PermissionsRolesEnum } from "@/enums"

export const getFirstAccessibleRoute = (
  userPermissions: PermissionsRolesEnum[] | undefined,
  isSuperAdmin: boolean = false
): string => {
  if (!userPermissions || userPermissions.length === 0) {
    return FRONTEND_ROUTES.LOGIN.href
  }

  const isAdmin = userPermissions.includes(
    PermissionsRolesEnum.ADMIN
  )

  for (const link of SIDEBAR_LINKS) {
    if (link.requireSuperAdmin && !isSuperAdmin) {
      continue
    }

    if (link.requireAdmin && !(isAdmin || isSuperAdmin)) {
      continue
    }

    if (link.permissionRoles.length === 0) {
      return link.href
    }

    if (isAdmin || isSuperAdmin) {
      return link.href
    }

    const hasPermission = link.permissionRoles.some(
      (role) => userPermissions.includes(role)
    )

    if (hasPermission) {
      return link.href
    }
  }

  return FRONTEND_ROUTES.LOGIN.href
}
